// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyC4kY_50trbHoBOWHuZtKYxnAYv07V7dxg",
  authDomain: "rayup-admin-panel.firebaseapp.com",
  databaseURL: "https://rayup-admin-panel-default-rtdb.firebaseio.com",
  projectId: "rayup-admin-panel",
  storageBucket: "rayup-admin-panel.firebasestorage.app",
  messagingSenderId: "402263971007",
  appId: "1:402263971007:web:687aecefe210cbcff1220a",
  measurementId: "G-DTVGR615K7",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
